import { ResolveFn } from '@angular/router';
import { SubscriptionService } from './subscription.service';
import { inject } from '@angular/core';
import { Observable, catchError, map, of, pipe } from 'rxjs';
import { PlanModel } from 'src/app/models/plan.model';
import { PlanGroupModel } from 'src/app/models/planGroup.model';

export const SubscriptionTemplateResolver: ResolveFn<PlanGroupModel[]> = (
  route,
  state,
  service: SubscriptionService = inject(SubscriptionService)): Observable<PlanGroupModel[]> =>

  service.getPlansByModule(route.paramMap.get('id')).pipe(
    map(service => {
      if (service) {
        return service;
      }
      console.log(`No onboarding service was found`);
      return null;
    }),
    catchError(error => {
      console.log(`Retrieval error: ${error}`);
      return of(null);
    })
);